import React from "react";
import { Link } from "react-router-dom"; 
import HC from '../../assets/images/HC.png';
import FF from '../../assets/images/FF.png';
import FV from '../../assets/images/FV.png';
import FNV from '../../assets/images/FNV.png';
import FNMS from '../../assets/images/FNMS.png';
import FP from '../../assets/images/FP.png';
import CD from '../../assets/images/CD.png';
import DG from '../../assets/images/DG.png';
import HH from '../../assets/images/HH.png';
import TCP from '../../assets/images/TCP.png';
import FA from '../../assets/images/FA.png';

import {getproductTitle} from "../utils/LanguageField";
function Menuitems({onMenuClick,items}) {
  //const [items,setItems] = useState([]);
  const productImageMap = {
    HC,
    FF,
    FV,
    FNV,
    FNMS,
    FP,
    CD,
    DG,
    HH,
    TCP,
    FA
  };
  
const handleClick = (itemName) => {
  onMenuClick(itemName); // Update the selected menu title in the parent
};

  const labelImages = {
    1: require("../../assets/images/HC.png"),
    2: require("../../assets/images/Halal-symbol.jpg"),
    3: require("../../assets/images/hequivalent.png"),
  };

  const productLabels = [
    { id: 1, label: "HEALTHIER CHOICE (HPB)" },
    { id: 2, label: "HALAL" },
    { id: 3, label: "HEALTHIER CHOICE EQUIVALENT" },
  ];
  return (
    <div className="heightscr- customscroll-">
      <div className="favmenuitem">
        {items.map((item, index) => (
          <div key={index} className="favmenuitem_slides">
            <Link to={`/menu-details/${((item.id != '') ? item.id : item._id)}`}
              state={{ name: item[getproductTitle('name', 'category')] }} onClick={() => handleClick(item[getproductTitle('name', 'category')])} className="">
              <figure>
                <img src={productImageMap[item.code]} alt="product" />
              </figure>
              <p>{item[getproductTitle('name', 'category')]}</p>
            </Link>
          </div>
        ))}

        {productLabels.map((pl) => (
          <div key={pl.id} className="favmenuitem_slides">
            <Link
              to={`/menu-details/${pl.label}`} 
              state={{ name: pl.label }}
            >
              <figure>
                <img src={labelImages[pl.id]} alt={pl.label} />
              </figure>
              <p>{pl.label}</p>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Menuitems;
